import React from "react";
// MUI Components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Checkbox from "@material-ui/core/Checkbox";

// Other Files
import { customTheme } from "../../constants/customTheme";
import classNames from "classnames";
import { remoteStatus } from "../../constants/constants";
const useStyles = makeStyles({
  root: (props) => ({
    ...customTheme(props.theme).dialog.root,
    minWidth: "750px",
  }),
  buttonContainer: customTheme().dialog.buttonContainer,
  title: customTheme().dialog.title,
  contentContainer: {
    ...customTheme().dialog.contentContainer,
    alignItems: "center",
  },
  contentItem: { marginBottom: "15px" },
  buttonPrimary: (props) => customTheme(props.theme).buttonPrimary,
  buttonOutlined: (props) => customTheme(props.theme).buttonOutlined,
  studyListItem: {
    padding: "0px",
  },
  studyList: (props) => ({
    width: "100%",
    overflowY: "auto",
    ...customTheme(props.theme).customScrollBar,
  }),
});

const LoadParticipantReviewConflictDialog = (props) => {
  const classes = useStyles(props);
  const modifyStudyDetails = () => {
    let modifyStudyDetails = [...props.studyDetails];
    props.cloudConflictStudies.map((studyId) => {
      let studyIndex = modifyStudyDetails.findIndex(
        (studyDict) => studyDict.id === studyId
      );

      modifyStudyDetails[studyIndex] = {
        ...modifyStudyDetails[studyIndex],
        studySource:
          modifyStudyDetails[studyIndex].remoteCopy.status ===
          remoteStatus.remoteVersion
            ? "REMOTE"
            : "LOCAL",
      };
    });
    return modifyStudyDetails;
  };
  const [modifiedStudyDetails, setModifiedStudyDetails] = React.useState(
    modifyStudyDetails()
  );
  const handleSubmit = () => {
    props.handleGetStudies(
      props.participantId,
      modifiedStudyDetails,
      props.selectedStudyIds
    );
    props.onClose();
  };

  const handleSelectStudy = (studyIndex) => {
    let newArr = [...modifiedStudyDetails];
    newArr[studyIndex].studySource =
      newArr[studyIndex].studySource === "REMOTE" ? "LOCAL" : "REMOTE";
    setModifiedStudyDetails(newArr);
  };

  const getConflictExplanationText = (status) => {
    switch (status) {
      case remoteStatus.remoteVersion: {
        return "A newer version of the study is on the cloud.";
      }
      case remoteStatus.cloudVersion: {
        return "An older version of the study is on the cloud.";
      }
      case remoteStatus.divergent: {
        return "The local and cloud versions of the study were independently modified and cannot be merged.";
      }
      default:
        return "";
    }
  };

  return (
    <Dialog
      open={props.open}
      PaperProps={{ className: classNames(classes.root) }}
    >
      {/* INFORMATION CARD */}
      <Typography
        variant="h4"
        color="textPrimary"
        align="center"
        className={classes.title}
      >
        Unsynced Studies
      </Typography>

      <DialogContent className={classes.contentContainer}>
        <Typography
          className={classes.contentItem}
          color="textPrimary"
          align="center"
        >
          Following studies exist on the device and are unsynced with the cloud.
          Select the studies you would like to download from the cloud.
          Downloading the study from the cloud will update and overwrite the
          local copy. This cannot be undone. Unselected studies will load the
          local copy.
        </Typography>

        <List className={classes.studyList}>
          {props.cloudConflictStudies.map((studyId) => {
            let studyIndex = modifiedStudyDetails.findIndex(
              (studyDict) => studyDict.id === studyId
            );

            return (
              <ListItem className={classes.studyListItem} key={studyId}>
                <ListItemIcon>
                  <Checkbox
                    color="primary"
                    onChange={() => handleSelectStudy(studyIndex)}
                    checked={
                      modifiedStudyDetails[studyIndex].studySource === "REMOTE"
                    }
                    value={modifiedStudyDetails[studyIndex].studySource}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <span>
                      Protocol Name:{" "}
                      {modifiedStudyDetails[studyIndex].protocolName} <br />{" "}
                      Study Date: {modifiedStudyDetails[studyIndex].studyDate}
                    </span>
                  }
                  secondary={getConflictExplanationText(
                    modifiedStudyDetails[studyIndex].remoteCopy.status
                  )}
                />
              </ListItem>
            );
          })}
        </List>
      </DialogContent>

      <DialogActions className={classes.buttonContainer}>
        <Button
          className={classes.buttonOutlined}
          onClick={() => props.onClose()}
          variant="outlined"
        >
          Cancel
        </Button>

        <Button
          onClick={() => handleSubmit()}
          variant="contained"
          color="primary"
          className={classes.buttonPrimary}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoadParticipantReviewConflictDialog;
